import React, { useState, useEffect } from 'react';
import {
  Button, Drawer, DrawerHeader, DrawerFooter, DrawerBody
} from '@one-thd/sui-atomic-components';
import { RefreshDrawerInfo } from './RefreshDrawerInfo';

const QuoteRefresh = () => {
  const [open, setOpen] = useState(false);
  const [refreshFn, setRefreshFn] = useState(() => { });

  useEffect(() => {
    const handleOpen = (event) => {
      setOpen(true);
      if (event?.output) {
        setRefreshFn(() => event?.output);
      }
    };
    LIFE_CYCLE_EVENT_BUS.on('quote.refreshQuote', handleOpen);
    return () => {
      LIFE_CYCLE_EVENT_BUS.off('quote.refreshQuote', handleOpen);
    };
  }, []);

  useEffect(() => {
    if (open) {
      LIFE_CYCLE_EVENT_BUS.trigger('quote-refresh.landOnOverlay');
    }
  }, [open]);

  const handleClick = () => {
    setOpen(false);
    refreshFn();
  };

  const handleCancel = () => {
    LIFE_CYCLE_EVENT_BUS.trigger('quote-refresh.exitOverlay');
    setOpen(false);
  };

  return (
    <Drawer
      open={open}
      position="right"
      onClose={handleCancel}
    >
      <DrawerHeader
        title="Refresh Quote and Update Pricing"
        onClose={handleCancel}
        data-testid="refreshQuote-drawer-header"
      />
      <DrawerBody>
        <RefreshDrawerInfo />
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="primary"
          data-testid="refresh-quote-action-button"
          onClick={handleClick}
        >
          Refresh Quote
        </Button>
        <div className="sui-pt-4">
          <Button
            fullWidth
            variant="secondary"
            onClick={handleCancel}
            data-testid="cancel-refresh-quote-action"
          >
            Cancel
          </Button>
        </div>
      </DrawerFooter>
    </Drawer>
  );
};

export { QuoteRefresh };
